//==============================
// Global
//==============================

FastClick.attach(document.body);

var w = $(window);
var ww = w.width();
var wh = w.height();
var html = $('html');
var body = $('body');

/*
$('.element').waypoint(function(direction) {
  var thisElement = $(this.element);
  //stuff
  this.destroy();
}, {
  offset: '50%'
});
*/

// $('.thing-with-videos').fitVids();
